import { text20Ft, text40Ft, textAdministrative, textAllocated, textBarge, textCassettesMafis, textContainer, textDepot, textDropOff, textEmpty, textEquipment, textFull, textFullEmpty, textHide, textHousekeeping, textInternal, textInternalTransportToStack, textModality, textNo, textNotAllocated, textOnlyMyOrders, textPickup, textQuayToStack, textRail, textReefer, textReeferNeedsPlugin, textRelocate, textReserveQuay, textSetOnTruck, textShow, textShuffle, textShunt, textSize, textStackToInternalTransport, textStackToQuay, textStackToWarehouse, textTrailer, textTransactionType, textTruck, textUnitType, textVessel, textWarehouseToStack, textYes } from 'src/app/shared/_config/i18n/i18n-interface';

import { OrdFilterEnum } from './ord-filters.enum';
import { OrdFilterGroupEnum } from './ord-filter-group.enum';
import { OrdFilterGroupI } from './ord-filter-group.interface';
import { OrdModalityEnum } from '../../ord-search/models/ord-modality.enum';
import { OrdSubStatusEnum } from '../../ord-search/models/ord-sub-status.enum';
import { OrdTransactionTypeEnum } from '../../../api/ord-process/models/ord-transaction-type.enum';
import { SpxInputTypeEnum } from '@softpak/components/spx-inputs';
import { releaseCheck } from '@softpak/components/spx-patch';

export const ordFilterConstants: OrdFilterGroupI[] = [
    {
        groupTextKey: textDepot,
        key: OrdFilterGroupEnum.ordDepot,
        filterType: SpxInputTypeEnum.autocomplete,
        readonly: true,
        filters: [
        ],
        isActive: false,
        defaultValue: undefined,
        hidden: true,
    },
    {
        groupTextKey: textEquipment,
        key: OrdFilterGroupEnum.ordEquipment,
        filterType: SpxInputTypeEnum.autocomplete,
        readonly: true,
        filters: [
        ],
        isActive: false,
        defaultValue: undefined,
        hidden: true,
    },
    {
        groupTextKey: textModality,
        key: OrdFilterGroupEnum.ordModality,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordModalityAdministrative,
                filterTextKey: textAdministrative,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.administrative,
            },
            {
                filterKey: OrdFilterEnum.ordModalityBarge,
                filterTextKey: textBarge,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.barge,
            },
            {
                filterKey: OrdFilterEnum.ordModalityInternal,
                filterTextKey: textInternal,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.internal,
            },
            {
                filterKey: OrdFilterEnum.ordModalityRail,
                filterTextKey: textRail,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.rail,
            },
            {
                filterKey: OrdFilterEnum.ordModalityTruck,
                filterTextKey: textTruck,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.truck,
            },
            {
                filterKey: OrdFilterEnum.ordModalityVessel,
                filterTextKey: textVessel,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdModalityEnum.vessel,
            },
        ],
        isActive: false,
        defaultValue: undefined,
    },
    {
        groupTextKey: textTransactionType,
        key: OrdFilterGroupEnum.ordTransactionType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordDropOff,
                filterTextKey: textDropOff,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdTransactionTypeEnum.dropOff,
            },
            {
                filterKey: OrdFilterEnum.ordPickup,
                filterTextKey: textPickup,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdTransactionTypeEnum.pickUp,
            },
            {
                filterKey: OrdFilterEnum.ordRelocate,
                filterTextKey: textRelocate,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdTransactionTypeEnum.relocate,
            },
            {
                filterKey: OrdFilterEnum.ordRelocate,
                filterTextKey: textReserveQuay,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdTransactionTypeEnum['reserve-quay'],
            },
        ],
        isActive: false,
        defaultValue: undefined,
    },
       {
        groupTextKey: textFullEmpty,
        key: OrdFilterGroupEnum.ordFullEmpty,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordFull,
                filterTextKey: textFull,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'F',
            },
            {
                filterKey: OrdFilterEnum.ordEmpty,
                filterTextKey: textEmpty,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'E',
            },
        ],
        isActive: false,
        defaultValue: undefined,
    },
        {
        groupTextKey: textRelocate,
        key: OrdFilterGroupEnum.ordRelocateType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordRelocateTypeHK,
                filterTextKey: textHousekeeping,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateHousekeeping,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeIS,
                filterTextKey: textInternalTransportToStack,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateInternalTransportToStack,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeQS,
                filterTextKey: textQuayToStack,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateQuayToStack,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeSH,
                filterTextKey: textShuffle,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateShuffle,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeSHN,
                filterTextKey: textShunt,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateShunt,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeSI,
                filterTextKey: textStackToInternalTransport,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateStackToInternalTransport,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeSQ,
                filterTextKey: textStackToQuay,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateStackToQuay,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeSW,
                filterTextKey: textStackToWarehouse,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateStackToWarehouse,
            },
            {
                filterKey: OrdFilterEnum.ordRelocateTypeWS,
                filterTextKey: textWarehouseToStack,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: OrdSubStatusEnum.relocateWarehouseToStack,
            },
        ],
        isActive: false,
        defaultValue: null,
    },
    {
        groupTextKey: textAllocated,
        key: OrdFilterGroupEnum.ordAllocated,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordAlloctedYes,
                filterTextKey: textAllocated,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdFilterEnum.ordAlloctedYes,
            },
            {
                filterKey: OrdFilterEnum.ordAlloctedOnlyMine,
                filterTextKey: textOnlyMyOrders,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdFilterEnum.ordAlloctedOnlyMine,
            },
            {
                filterKey: OrdFilterEnum.ordAlloctedNo,
                filterTextKey: textNotAllocated,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: OrdFilterEnum.ordAlloctedNo,
            }
        ],
        isActive: false,
        defaultValue: undefined,
    },
    {
        groupTextKey: textSize,
        key: OrdFilterGroupEnum.ordSize,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordSize20Ft,
                filterTextKey: text20Ft,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 20,
            },
            {
                filterKey: OrdFilterEnum.ordSize40Ft,
                filterTextKey: text40Ft,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 40,
            }
        ],
        isActive: false,
        defaultValue: undefined,
    },
    {
        groupTextKey: textReefer,
        key: OrdFilterGroupEnum.ordReefersContainerType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordReeferContainerTypeYes,
                filterTextKey: textYes,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'reefer',
            },
            {
                filterKey: OrdFilterEnum.ordReeferContainerTypeNo,
                filterTextKey: textNo,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'nonReefer',
            }
        ],
        isActive: false,
        defaultValue: undefined,
    },
    ...(!releaseCheck('26.01') ? [{
        groupTextKey: textReeferNeedsPlugin,
        key: OrdFilterGroupEnum.ordReefersPlugin,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordReeferPluginYes,
                filterTextKey: textYes,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'reefer',
            },
            {
                filterKey: OrdFilterEnum.ordReeferPluginNo,
                filterTextKey: textNo,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: 'nonReefer',
            }
        ],
        isActive: false,
        defaultValue: undefined,
    }] : []),
    {
        groupTextKey: textUnitType,
        key: OrdFilterGroupEnum.ordUnitType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordUnitTypeCassettes,
                filterTextKey: textCassettesMafis,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: 'cassette',
            },
            {
                filterKey: OrdFilterEnum.ordUnitTypeContainer,
                filterTextKey: textContainer,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: 'container',
            },
            {
                filterKey: OrdFilterEnum.ordUnitTypeTrailer,
                filterTextKey: textTrailer,
                filterTextVariables: {},
                defaultValue: false,
                targetValue: 'trailer',
            },
        ],
        isActive: false,
        defaultValue: undefined,
        hidden: true,
    },
    {
        groupTextKey: textSetOnTruck,
        key: OrdFilterGroupEnum.ordOnTheWayOut,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: OrdFilterEnum.ordOnWayOutHide,
                filterTextKey: textHide,
                filterTextVariables: {
                },
                defaultValue: true,
                targetValue: false,
            },
            {
                filterKey: OrdFilterEnum.ordOnWayOutShow,
                filterTextKey: textShow,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: true,
            },
        ],
        isActive: false,
        defaultValue: false,
    },
];
